import { ProductExperienceService } from '$lib/services/product-experience';
import { AOFL_PRODUCT_NAMES } from '$lib/utils/constants';
import { ACTIVE_EXPERIMENTS } from '$lib/services/experiments/client/constants';
import { experimentService } from '$lib/services/experiments/client';

/**
 *  @type {{[key: string]: import('$lib/utils/page').PageCondition}} conditions - The conditions object containing the conditions to be resolved.
 */
const pageConditions = {
	inApp: {
		condition: async (config) => {
			return config.meta.inApp;
		},
		resolve: async () => {
			await ProductExperienceService.setProductExperience(AOFL_PRODUCT_NAMES.ABCMOUSE);
			return await import('../_in-app/Page.svelte');
		},
	},
	magicLinkExperiment: {
		condition: async () => {
			const { experimentKey, variants } = ACTIVE_EXPERIMENTS.ABCM2_MAGIC_LINK;
			return await experimentService.isAnyExperimentArmActive(
				experimentKey,
				[variants.test],
				{ page_name: 'login', page_url: '/login' },
				false
			);
		},
		resolve: async () => await import('../_login-magic-link/Page.svelte'),
	},
	default: {
		condition: async () => true,
		resolve: async () => await import('../_browser-2-0-rebrand/Page.svelte'),
	},
};

export { pageConditions };
